import constants from "../constants"

const Breakpoints = (w) => {
  const between = (x, min, max) => {
    return x >= min && x <= max
  }
  const brakes = [
     { id: `320`, min: 0, max: 320 },
     { id: `640`, min: 320, max: 640 },
     { id: `960`, min: 640, max: 960 },
     { id: `1200`, min: 960, max: Infinity },
  ]
  return brakes.filter(item => between(w, item.min, item.max))[0]
}

export default Breakpoints